// extracted by mini-css-extract-plugin
export var icon = "_4j-1";
export var subtext = "_4j-0";